export const ACTION_ITEM_HEIGHT = 24;
export const OPTION_ITEM_HEIGHT = 45;
export const ITEM_MARGIN = 5;
export const INPUT_HEIGHT = 24;
export const CONTAINER_HORIZONTAL_PADDING = 10;
